/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { SimpliCityAdminSDK } from "@simplicitycms/simplicity-admin-js-sdk";
import { uploadFileAzure } from "cms/integration/azure/storage/azure-storage";
import { useAuth } from "cms/auth/hooks/use-auth";
import { Logger } from "cms/utils/log/logger";

const useUploadFile = () => {
    
    const { token } = useAuth();
    // ---------------------------------------------------------------
    // main upload function
    // ---------------------------------------------------------------
    
    const uploadFile = async (props) => {
        
        const {
            image,
            file,
            file_name,
            onImageUploaded,
            setUploadStatus,
        } = props;
        
        // await requestMSALToken()
        let updated_image;
        
        // get an User Delegate SAS - for Azure Storage Blob
        const sas_response = await SimpliCityAdminSDK.images.getToken(token);
        // Token has configuration available inside
        const {
            sas,
            // storageAccountName,
            storageAccount,
            containerName,
            // fileUrlBase
        } = sas_response;
        // Logger.debug('SAS TOKEN', sas)
        
        // *** UPLOAD TO AZURE STORAGE ***
        Logger.debug(`Uploading file: ${file_name}`);
        Logger.debug(`Storage: ${storageAccount}/${containerName}`);
        setUploadStatus({ status: "INCOMPLETE", message: "The upload has begun." });
        const uploadResult = await uploadFileAzure(storageAccount, containerName, file, sas);
        setUploadStatus(uploadResult);
        if (uploadResult.status === "ERROR") {
            Logger.error(uploadResult);
            throw Error(uploadResult.message);
        } else {
            updated_image = {
                guid: image?.guid,
                title: image?.title,
                description: image?.description,
                alt: image?.alt || "",
                width: image?.width,
                height: image?.height,
                storage_account: image?.storage_account,
                storage_container: containerName,
                storage_filepath: image?.storage_filepath,
                storage_url: image?.storage_url,
                type: image?.type,
                url: image?.url,
                file_name: image?.file_name,
                file_ext: image?.ext,
                file_type: file.type,
                file_size: file.size,
                archived: image?.archived === 1 || false,
            };
        }
        onImageUploaded(updated_image);
    };
    
    return {
        uploadFile
    };
    
};

export { useUploadFile };
